"use strict";

const hash = window.location.hash;
if(hash && hash === '#cart-remove'){
  removeItemAlert();
  window.location.hash = '';
}

function removeItemAlert(){
  const removeAlertNode = document.querySelector('[data-remove-alert]');
  if(!removeAlertNode) return;
  removeAlertNode.setAttribute('tabindex', 0);
  removeAlertNode.classList.remove('hidden');
  removeAlertNode.focus();

  removeAlertNode.addEventListener('blur', function(){
    this.setAttribute('tabindex', -1);
    this.classList.add('hidden');
  });
  // jQuery('[data-remove-alert]').attr('tabindex',0).removeClass('hidden').focus();
  // jQuery('[data-remove-alert]').off('blur').on('blur', function(){
  //   jQuery('[data-remove-alert]').addClass('hidden').attr('tabindex', -1);
  //   jQuery('[data-remove-alert]').off('blur');
  // });
}

_theme.Cart = (function(){
  const offerConfig = _theme.gwpConfig;
  let cartjson = _theme.gwpConfig.cart;

  function initCartEvetns(cart){
    jQuery(document).find("[data-block-qty] a.buttonHandler").on("click", function(e) {
      const _this = jQuery(this);
      const input = _this.parent().find('input');
      let qty = parseInt(input.val());
      const isPlus = _this.hasClass('plus');
      
      const originalValue = input.attr('data-value');
      const originalQty = originalValue ? parseInt(originalValue) : qty;

      let lineIndex = _this.closest(".item").attr("line-index");
      _this.parent().find('.buttonHandler').addClass('disabled');
      enableOrDisableSection(false);
      const lineIndexValue = lineIndex.match(/\d+/g);
      
      if(!lineIndexValue) return;

      lineIndex = lineIndexValue[0];
      
      updateStatusAccessibility(lineIndex, 'in-progress', isPlus);
      
      if(isPlus) qty += 1;
      else qty -= 1;
      qty = qty < 0 ? 0 : qty;
      input.val(qty);

      let updatedQty = isPlus ? originalQty + 1 : originalQty - 1;
      updatedQty = updatedQty < 0 ? 0 : updatedQty;

      changeLineItemQty(lineIndex, updatedQty, function(res){
        if(res && res.error){
          input.val(originalQty).attr('data-value', originalValue);
          
          jQuery('[data-block-qty] input').not(input).each(function() {
            const $otherInput = jQuery(this);
            const otherValue = $otherInput.attr('data-value') || $otherInput.closest('li').attr('data-quantity');
            if(otherValue) {
              $otherInput.val(otherValue).attr('data-value', otherValue);
            }
          });
          
          updateStatusAccessibility(lineIndex, 'error', res.message || 'Something went wrong');
        } else if(res && res.statusText && res.statusText === "error"){
          input.val(originalQty).attr('data-value', originalValue);
          updateStatusAccessibility(lineIndex, 'error', res.responseJSON.description);
        } else {
          if(qty > 0) updateStatusAccessibility(lineIndex, 'done', isPlus);
          else removeItemAlert();
        }
        _this.parent().find('.buttonHandler').removeClass('disabled');
        enableOrDisableSection(1);
      });
    });

    jQuery('#checkout_consent').on('change', function(evt){
      if(jQuery(this).prop('checked')){
        jQuery('[name="checkout"]').removeAttr('disabled');
      } else {
        jQuery('[name="checkout"]').attr('disabled', true);
      }
    });

    initGWP();
    initAutoFreeGift();
  }

  function initGWP(){
    let isAdding = false, result = null;
    if(!offerConfig || !offerConfig.gwp) return;
    if(!offerConfig.gwp.enable) {
      init(true);
      return;  
    }
    if(offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time

    init();
    
    function init(stopInitialization){
      const gwp = offerConfig.gwp;
      result = getApplicableData(cartjson, gwp);
      
      if(!result.applicable && result.giftLineItem){
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 0, 1, cartUpdateCallBack);
      } else if(result.giftLineItem && result.giftLineItem.quantity > 1){
        _theme.Helpers.changeLineItemQty(result.giftLineItem.key, 1, 1, cartUpdateCallBack);
      } else {
        if(!stopInitialization) run();
      }
    }

    function getApplicableData(cart, gwp){
      const result = {giftLineItem: null, applicable: false, applicableOffer: null, giftLineItemIndex: -1};
      
      if(!cart || cart.item_count === 0) return result;
  
      let cartTotal = cart.total_price;
      const giftLineItems = cart.items.filter(({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount !== undefined);
      const giftLineItem = giftLineItems[0];
      const giftLineItemIndex = cart.items.findIndex(({ properties = {} }) => properties?._type === 'gwp' && properties?._discAmount !== undefined);
      if(giftLineItem) cartTotal -= giftLineItem.final_line_price;
      cartTotal /= 100;
      const applicableOffer = gwp.offers.find(offer => cartTotal >= offer.threshold);
  
      if(applicableOffer) {
        result['applicableOffer'] = applicableOffer;
        if(!giftLineItem) result['applicable'] = true;
      }
  
      if(giftLineItem) {
        result['giftLineItem'] = giftLineItem;
        result['giftLineItemIndex'] = giftLineItemIndex;
  
        if(applicableOffer){
            const offerHasAddedGiftLine = applicableOffer.products.some(prod => prod.variant_id === giftLineItem.variant_id);
            result['applicable'] = offerHasAddedGiftLine && (Number(applicableOffer.discAmount) === Number(giftLineItem.properties?._discAmount));
        } else {
            result['applicable'] = false;
        }
      }

      if(giftLineItems.length > 1){
        result['applicable'] = false;
      }
  
      if(!gwp.enable) result['applicable'] = false;
  
      return result;
    }

    function openGWPModal(evt){
      if(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      const attr = JSON.parse(jQuery('[data-gwp-modal]').attr('aria-hidden') || false);
      jQuery('[data-gwp-modal]').attr('aria-hidden', !attr).stop().slideToggle();
    }

    function closeGWPModal(evt){
      if(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      }

      jQuery('[data-gwp-modal]').attr('aria-hidden', true).stop().slideUp();
    }

    function cartUpdateCallBack(resp){
      closeGWPModal();
      cartMapData(resp);
      jQuery('[data-gwp-modal] .btn-gwp').removeClass('loading');
      isAdding = false;
    }

    function run(){
      jQuery('[data-gwp-trigger]').off('click', openGWPModal).on('click', openGWPModal);

      jQuery('[data-gwp-modal] [data-gwp-modal-close]').off('click', closeGWPModal).on('click', closeGWPModal);

      jQuery('[data-gwp-modal] .btn-gwp-apply').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        if(isAdding || !result.applicableOffer) return;
        const vid = jQuery(this).data('vid');
        if(!vid) return;
        
        isAdding = true;
        jQuery(this).addClass('loading');
        
        _theme.Helpers.addProductToCart(vid,1, {
          "_type": result.applicableOffer.type,
          "_discAmount": result.applicableOffer.discAmount
        }, cartUpdateCallBack);
      });

      jQuery('[data-gwp-modal] .btn-gwp-remove').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const lineItemKey = jQuery(this).data('lineitem-key');
        if(isAdding || !lineItemKey) return;
        isAdding = true;
        jQuery(this).addClass('loading');
        _theme.Helpers.changeLineItemQty(lineItemKey,0, 1, cartUpdateCallBack);
      });

      jQuery('[data-gwp-modal] .btn-gwp-update').off('click').on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const vid = jQuery(this).data('vid');
        const lineItemKey = jQuery(this).data('lineitem-key');
        if(isAdding || !lineItemKey || !vid) return;

        isAdding = true;
        jQuery(this).addClass('loading');
        _theme.Helpers.changeLineItemQty(lineItemKey,0, 1, function(cart){
          _theme.Helpers.addProductToCart(vid,1, {
            "_type": result.applicableOffer.type,
            "_discAmount": result.applicableOffer.discAmount
          }, cartUpdateCallBack);
        });
      });
    }
  }

  function initAutoFreeGift(){
    if(!offerConfig || !offerConfig.gwp_auto) return;
    // if(!offerConfig.gwp_auto.enable) return;
    
    const gwp_enable = offerConfig.gwp.enable;
    const gwp_auto = offerConfig.gwp_auto;
    const cart_total_amt = cartjson.total_price / 100;
    const threshold = Number(gwp_auto.threshold);
    const vid = gwp_auto.vid;

    // if(offerConfig.gwp.enable && offerConfig.gwp_auto.enable) return; // Can't run both offer at a time

    const $giftElem = jQuery('.cart-section-items-in .cart-section-item[data-free-gift-added="true"]');
    const isAdded = $giftElem.length > 0 ? true : false;
    if(isAdded){
      if(cart_total_amt < threshold || !gwp_auto.enable){
        const viaId = vid ? true : false;
        const lineIndex = vid ? vid : $giftElem.attr('line-index');

        changeLineItemQty(lineIndex, 0, function(){
          window.location.href = window.location.href;
        },1,viaId);
      } else {
        const qty = parseInt($giftElem.attr('data-quantity'));
        if(qty && qty > 1){
          const newQty = gwp_auto.enable ? 1 : 0;
          _theme.Helpers.changeLineItemQty(vid,newQty, 1, cartUpdateCallBack);
        }
      }
    } else {
      if(!gwp_enable && gwp_auto.enable){
        if(cart_total_amt >= threshold){
          addFreeGiftProduct(vid, 1, 'freeGift');
        } 
      }
    } 
  }

  function updateStatusAccessibility(lineIndex, status, isPlusOperation){
    const $lineitemElem = jQuery('.cart-template .cart-section-items-in .item[line-index="'+lineIndex+'"]');
    if(!lineIndex) jQuery('[data-aria-live]').text('');
    if(!lineIndex || $lineitemElem.length === 0) return;
    
    let msg = '';
    const $ariaLive = $lineitemElem.find('[data-aria-live]');
    if(status === 'in-progress') {
      if(isPlusOperation) msg = 'please wait increase quantity Item';
      else msg = 'please wait decrease quantity Item';
    }
    if(status === 'done'){
      $ariaLive.empty();
      if(isPlusOperation) {
        msg = 'Increased successfully by 1';
        $lineitemElem.find('[data-block-qty] .plus').focus();
      } else {
        msg = 'Decreased successfully by 1';
        $lineitemElem.find('[data-block-qty] .minus').focus();
      }
    }

    if(status === 'error'){
      msg = isPlusOperation; // Passing error msg incase error
    }

    setTimeout(function(){
      $ariaLive.empty().text(msg);
    }, 250);
  }

  function changeLineItemQty(line, qty, callback, disableAjax, viaId){
    let data = { quantity: qty, line: line, sections: 'gwp,minicart', sections_url: '/' }
    if(viaId){
      data = { quantity: qty, id: line, sections: 'gwp,minicart', sections_url: '/' }
    }

    jQuery.ajax({
      type: "post",
      url: "/cart/change.js",
      data: data,
      dataType: 'json',
      success:function(data){
        
        if(!viaId && _theme.Helpers.checkBOGOQuantityLimit(data, line, qty, '.cart-template .cart-section-items', callback)) {
          return; // Error was handled by checkBOGOQuantityLimit
        }
        
        if(disableAjax){
          if(callback && typeof callback === 'function') callback(data);
        } else {
          cartMapData(data, callback);
        }
      },
      error:function(err){
        if(err && err.responseText) {
          const errorData = JSON.parse(err.responseText);
          const customErrorMessage = _theme.Helpers.customQuantityLimitMessage(errorData.description, errorData);
          _theme.toggleAjaxModal(1, customErrorMessage);
        } else {
          _theme.toggleAjaxModal(1, 'Something went wrong');
        }
        if(callback && typeof callback === 'function') callback(err);
      }
    });
  }

  function cartMapData(resp, callback){
    if(!resp.sections || !resp.sections.minicart) {
      alert('Something went wrong');
      return;
    }

    const newMiniCart = _theme.Helpers.stringToHTML(resp.sections.minicart);
    const cart = JSON.parse(newMiniCart.querySelector('minicart-block script').textContent);
    cartjson = cart;

    const cartSectionInner = newMiniCart.querySelector('cart-block .cart-section-inner');
    const cartFreeShip = newMiniCart.querySelector('cart-block .freeship');
    const cartOrderCard = newMiniCart.querySelector('cart-block .order-card');
    const cartKlarnaWrap = newMiniCart.querySelector('cart-block .klarna-wrap');
    const cartMobTotalPrice = newMiniCart.querySelector('cart-block .order-card .order-totle-price .value');
    const cartMobTotalCount = newMiniCart.querySelector('cart-block .order-card .your-order-count-mob .right .cart_count');
    if(cartSectionInner) jQuery('.cart-left-col .cart-section-inner').html(cartSectionInner.innerHTML);
    if(cartFreeShip) jQuery('.cart-left-col .freeship').html(cartFreeShip.innerHTML);
    if(cartOrderCard) jQuery('.cart-right-col .order-card').html(cartOrderCard.innerHTML);
    if(cartKlarnaWrap) jQuery('.cart-right-col .klarna-wrap').html(cartKlarnaWrap.innerHTML);
    if(cartMobTotalPrice) jQuery('.mob-cart-price').html(cartMobTotalPrice.innerHTML);
    if(cartMobTotalCount) jQuery('.mob-cart-count .mob-cart-count-span').html(cartMobTotalCount.innerHTML);
    jQuery('.cart_count').text(cart.item_count);
    if(cart.item_count == 0){
      prodSlider(); 
      jQuery('.mob-cart-price').html(Shopify.formatMoney(0));
      jQuery('.mob-cart-count .mob-cart-count-span').html(0)
    }
    else{
      prodSlider()
    }
    _theme.updateGWP(resp);
    initCartEvetns(cart);
    if(callback && typeof callback === 'function') callback(cart);
  }

  function addFreeGiftProduct(vid, qty, props){
    jQuery.ajax({
      url: window.routes.cart_add_url + '.js',
      method: 'POST',
      beforeSend: function() {
        _theme.toggleLoading(1);
      },
      data: {
        quantity: qty,
        id: vid,
        properties:{
          _proType: props
        }
      },
      dataType: 'json',
      success:function(){
        _theme.toggleLoading();
        enableOrDisableSection(true);
        window.location.reload();
      },
      error: function(err){
        _theme.toggleAjaxModal(1, JSON.parse(err.responseText).description);
        setTimeout(function(){
          window.location.reload();
        }, 2000);
      },
      complete: function(){
        _theme.toggleLoading();
      }
    });
  }

  function enableOrDisableSection(enable){
    if(enable) jQuery('.cart-template').removeClass('processing');
    else jQuery('.cart-template').addClass('processing');
  }

  return {
    initCartEvetns: initCartEvetns,
    //changeLineItemQty: changeLineItemQty,
    cartMapData: cartMapData
  }
})();

_theme.initAccessibility = function(){
  const paymentInterval = setInterval(function(){
    const $paymentButtons = jQuery('#dynamic-checkout-cart');
    if($paymentButtons.length && $paymentButtons.find('li').length){
      $paymentButtons.find('li [role="button"]').attr('role', 'link');
      clearInterval(paymentInterval);
    }
  }, 500);

  setTimeout(function(){
    if(paymentInterval) clearInterval(paymentInterval);
  }, 8000);


  setTimeout(function(){


    var darkSvg = jQuery('#shopify-svg__payments-facebook-pay-dark')
    var lightSVg  =  jQuery('#shopify-svg__payments-facebook-pay-light')


    if(lightSVg){
      jQuery('#shopify-svg__payments-facebook-pay-light').remove()

    }

    if(darkSvg){

      jQuery('#shopify-svg__payments-facebook-pay-dark').remove()

    }
   
    



  },4000);
}


jQuery(function(){
  _theme.Cart.initCartEvetns();

  jQuery('.cart-order-link .link_item').on('click',function(){
    jQuery(this).parent().toggleClass('active').siblings().removeClass('active');
    jQuery(this).next().slideToggle().parent().siblings().find('.body').slideUp()
    jQuery(this).parent().hasClass('active') ? jQuery(this).attr('aria-expanded','true') : jQuery(this).attr('aria-expanded','false');
  })

});
window.onload = _theme.initAccessibility;
